import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';
import _ from 'lodash';

import SelectSitesTable from 'Common/SelectSitesTableReduxForm';
import { caseInsensitiveStartsWithFilter } from 'Common/GridHelper';
import { DEFAULT_LABOR_HOURS_FORM_NAME, InputMode } from 'Common/FormEnum';
import { DefaultLaborHoursFieldEnum as Fields } from 'Common/FieldEnum';
import { InputField, SelectField } from 'Common/SemanticWrapper';
import { formatDecimal } from 'Common/FormHelper';
import { TitledCard } from 'Components';

class DefaultLaborHoursFormContainer extends Component {
  state = {
    additionalColumns: [
      {
        Header: 'Default Labor Hours',
        resizable: false,
        headerStyle: {
          textAlign: 'left',
          marginLeft: 0,
          display: 'flex',
          alignItems: 'center',
          padding: '7px 0',
        },
        id: 'Default Labor Hours',
        sortable: false,
        filterable: true,
        filterMethod: caseInsensitiveStartsWithFilter,
        accessor: (d) => formatDecimal(2)(d.DefaultLaborHours),
        Aggregated: (row) => {
          return null;
        },
      },
    ],
  };

  onGroupBySiteChange = (isGroupBySite) => {
    const { additionalColumns } = this.state;
    const newAdditionalColumns = _.cloneDeep(additionalColumns);
    newAdditionalColumns[0].filterable = !isGroupBySite;

    this.setState({
      additionalColumns: newAdditionalColumns,
    });
  };

  render() {
    const {
      loading,
      fiscalYearOptions,
      handleFiscalYearChange,
      sites,
    } = this.props;
    return (
      <Form>
        <TitledCard title={'Edit Default Labor Hours'}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={3}>
                <Field
                  label={'Fiscal Year'}
                  loading={loading}
                  disabled={loading}
                  name={Fields.FiscalYear}
                  options={fiscalYearOptions}
                  component={SelectField}
                  onChange={handleFiscalYearChange}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={3}>
                <Field
                  label={'Scheduled Labor Hours'}
                  loading={loading}
                  disabled={loading}
                  name={Fields.DefaultLaborHours}
                  formatOnBlur={formatDecimal(2, true)}
                  mode={InputMode.Decimal}
                  numericSize={[6, 2]}
                  component={InputField}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
        <TitledCard title={'Select Sites to Apply Default Labor Hours'}>
          <Field
            name={Fields.Sites}
            loading={loading}
            component={SelectSitesTable}
            onGroupBySiteGroupChange={this.onGroupBySiteChange}
            sites={sites}
            fetchSites={false}
            showPageSizeOptions={true}
            additionalColumns={this.state.additionalColumns}
          />
        </TitledCard>
      </Form>
    );
  }
}

const validate = (values) => {
  const errors = {};

  if (
    !values[Fields.Sites] ||
    (Array.isArray(values[Fields.Sites]) && !values[Fields.Sites].length)
  ) {
    errors[Fields.Sites] = 'At least one site must be selected.';
  }

  return errors;
};

export const DefaultLaborHoursForm = reduxForm({
  validate,
  form: DEFAULT_LABOR_HOURS_FORM_NAME,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(DefaultLaborHoursFormContainer);



// WEBPACK FOOTER //
// ./src/pages/defaultlaborhours/components/DefaultLaborHoursForm.js